// Track if social share has been initialized globally
let socialShareInitialized = false;

export function initSocialShare() {
  // Prevent double initialization
  if (socialShareInitialized) return;
  socialShareInitialized = true;

  document.querySelectorAll('[data-social-share]').forEach(root => {
    if (root._socialShareBound) return;
    root._socialShareBound = true;

    const link = root.getAttribute('data-social-share-link') || location.href;
    const title = root.getAttribute('data-social-share-title') || document.title;

    root.addEventListener('click', e => {
      const btn = e.target.closest('[data-social-share-type]');
      if (!btn) return;
      e.preventDefault();

      const type = btn.getAttribute('data-social-share-type');
      const u = encodeURIComponent(link);
      const t = encodeURIComponent(title);

      const map = {
        x: `https://twitter.com/intent/tweet?text=${t}&url=${u}`,
        linkedin: `https://www.linkedin.com/sharing/share-offsite/?url=${u}`,
        reddit: `https://www.reddit.com/submit?url=${u}&title=${t}`,
        telegram: `https://t.me/share/url?url=${u}&text=${t}`,
        whatsapp: `https://api.whatsapp.com/send?text=${t}%20${u}`,
        mail: `mailto:?subject=${t}&body=${t}%0A%0A${u}`,
        facebook: `https://www.facebook.com/sharer/sharer.php?u=${u}`,
        pinterest: `https://www.pinterest.com/pin/create/button/?url=${u}&description=${t}`,
      };

      if (type === 'clipboard') {
        navigator.clipboard.writeText(link).then(() => {
          btn.setAttribute('data-social-share-success', '');
          setTimeout(() => btn.removeAttribute('data-social-share-success'), 2000);
        });
        return;
      }

      const url = map[type];
      if (url) window.open(url, '_blank', 'noopener,noreferrer');
    });
  });
}